import { apiCall } from './api-call-helper'
import { createBackendActionsClient, systemClientClock, type BackendActionsClient } from '@bt-common/scheduling'

export function createExtensionBackendActionsClient(): BackendActionsClient {
    return createBackendActionsClient({
        post: (path, body) => apiCall<any>('post', path, body),
        // FE#447: every request tells the server what THIS machine's clock says; the server computes and logs the
        // skew per request. The extension keeps no clock model of its own — it obeys the server's verdict
        // (`retryAfterMs` on not_yet_due, see offer-holds.ts).
        clock: systemClientClock,
    })
}
